import { Component } from '@angular/core';
import {
  FormBuilder,
  FormGroup,
  ReactiveFormsModule,
  Validators,
  AbstractControl,
  ValidationErrors,
} from '@angular/forms';

import { DoctorService } from '../../services/doctor.service';
import { MatDialogRef } from '@angular/material/dialog';
import { ErrorPanelService } from '../../services/error-panel.service';
import { DoctorFiscalIdRequestModel } from '../../models/api/billing-data.api.model';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';

@Component({
  selector: 'app-fiscal-code-panel',
  standalone: true,
  imports: [ReactiveFormsModule, MatProgressSpinnerModule],
  templateUrl: './fiscal-code-panel.component.html',
  styleUrl: './fiscal-code-panel.component.scss',
})
export class FiscalCodePanelComponent {
  fiscalForm: FormGroup;
  isLoading: boolean = false;

  private fiscalCodeValidator(
    control: AbstractControl
  ): ValidationErrors | null {
    const value = control.value;
    if (!value) return null;

    const fiscalCodePattern =
      /^[A-Z]{6}[0-9LMNPQRSTUV]{2}[ABCDEHLMPRST]{1}[0-9LMNPQRSTUV]{2}[A-Z]{1}[0-9LMNPQRSTUV]{3}[A-Z]{1}$/;

    return fiscalCodePattern.test(value.toUpperCase())
      ? null
      : { invalidFormat: true };
  }

  constructor(
    private fb: FormBuilder,
    private doctorService: DoctorService,
    public dialogRef: MatDialogRef<FiscalCodePanelComponent>,
    public errorPanelService: ErrorPanelService
  ) {
    this.isLoading = false;
    this.fiscalForm = this.fb.group({
      first_name: ['', Validators.required],
      last_name: ['', Validators.required],
      fiscal_code: ['', [Validators.required, this.fiscalCodeValidator]],
    });
  }

  onSubmit() {
    if (this.fiscalForm.valid) {
      console.log('Form submitted:', this.fiscalForm.value);
      const obj: DoctorFiscalIdRequestModel = {
        first_name: this.fiscalForm.value.first_name,
        last_name: this.fiscalForm.value.last_name,
        codice_fiscale: this.fiscalForm.value.fiscal_code.toUpperCase(),
      };
      this.isLoading = true;
      this.doctorService.updateDoctorFiscalCode(obj).subscribe({
        next: (response) => {
          console.log('Doctor fiscal code updated:', response);
          this.isLoading = false;
          this.dialogRef.close(true);
        },
        error: (error) => {
          console.error('Error updating doctor fiscal code:', error);
          this.errorPanelService.showErrorSnackBar(
            "Errore nell'aggiornamento dei dati fiscali. Per favore verifica che il codice fiscale sia corretto."
          );
          this.isLoading = false;
        },
      });
    }
  }
}
